import {ROOT_URL, MAX_ERROR_TEXT_LEN} from '@/store';

const REQUEST_LINK = '/subscription/disconnect_user/';

function disconnectUser(userId, handler) {
  const sendForm = new FormData();
  sendForm.set('disconnect_user_id', userId);

  fetch(ROOT_URL + REQUEST_LINK, {
    method: 'POST',
    credentials: 'include',
    body: sendForm,
  }).then(async (response) => {
    if (response.status == 200) {
      handler({
        status: response.status,
        text: 'ok',
      });
      return;
    }

    handler({
      _error: true,
      status: response.status,
      text: `Ошибка отключения пользователя. ${(await response.text()).trimLen(MAX_ERROR_TEXT_LEN)}`,
    });
  }).catch((errData) => {
    handler({
      _error: true,
      status: null,
      text: 'Ошибка подключения к серверу',
    });
  });
}

export default disconnectUser;
